module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\n<div class=\"custom-control custom-checkbox swhid-option\">\n  <input class=\"custom-control-input\" value=\"option-user-requests-filter\" type=\"checkbox\"\n    ")
    ;  if (checked) { 
    ; __append("\n         checked=\"checked\"\n    ")
    ;  } 
    ; __append("\n         id=\"")
    ; __append(escapeFn( inputId ))
    ; __append("\">\n  <label class=\"custom-control-label font-weight-normal\" for=\"")
    ; __append(escapeFn( inputId ))
    ; __append("\">\n    show only your own requests\n  </label>\n</div>\n")
  }
  return __output;

}